import { customerAtom } from 'atons/Customer/atoms';
import { useToast } from 'customHooks/useToast';
import { useAtomValue } from 'jotai';
import { useQuery } from 'react-query';
import { queryKeys } from 'react-query/constants';
import AttributeTypes from 'enums/AttributeTypes';
import { getCustomFieldPicklistOptions } from 'services/attributeManagementApis';
import { ReactQueryHookOption } from 'react-query/types';

const useGetChildPicklistOptions = (
    customFieldId: number,
    type: number,
    options: ReactQueryHookOption<unknown> = { enabled: true }
) => {
    const customer = useAtomValue(customerAtom);
    const toast = useToast();
    return useQuery(
        [queryKeys.getChildPicklistOptions, String(customer?.clientId), Number(customFieldId)],
        getCustomFieldPicklistOptions,
        {
            enabled: !!customer?.clientId && !!customFieldId && AttributeTypes.Checkbox === type && !!options.enabled,
            retry: 3,
            refetchOnWindowFocus: false,
            onError: error => {
                console.log(error);
                toast.error('Something went wrong, try again later.');
            },
        }
    );
};

export default useGetChildPicklistOptions;
